import React from 'react';
// import { Status } from '../../styles';

export default function CreditTable() {
    return (
        <table className={'point-table'}>
            <thead>
                <tr align='center'>
                    <th>No</th>
                    <th>Status</th>
                    <th>Request Date / Time</th>
                    <th>Processing Date / Time</th>
                </tr>
            </thead>
            <tbody>
                <tr align='center'>
                    <td className='td-number'>1</td>
                    <td>{/*<Status status='4'>Pending</Status>*/}</td>
                    <td>24.08.2019 / 14:23:03</td>
                    <td>24.08.2019 / 14:23:03</td>
                </tr>

                <tr align='center'>
                    <td className='td-number'>2</td>
                    <td>{/*<Status status='4'>Pending</Status>*/}</td>
                    <td>24.08.2019 / 14:23:03</td>
                    <td>24.08.2019 / 14:23:03</td>
                </tr>
                <tr align='center'>
                    <td className='td-number'>3</td>
                    <td>{/*<Status status='4'>Pending</Status>*/}</td>
                    <td>24.08.2019 / 14:23:03</td>
                    <td>24.08.2019 / 14:23:03</td>
                </tr>
                <tr align='center'>
                    <td className='td-number'>4</td>
                    <td>{/*<Status status='5'>Completed</Status>*/}</td>
                    <td>24.08.2019 / 14:23:03</td>
                    <td>24.08.2019 / 14:23:03</td>
                </tr>
                <tr align='center'>
                    <td className='td-number'>5</td>
                    <td>{/*<Status status='6'>Denied</Status>*/}</td>
                    <td>24.08.2019 / 14:23:03</td>
                    <td>24.08.2019 / 14:23:03</td>
                </tr>
            </tbody>
        </table>
    );
}
